<template>
  <div class="text-center">
    <v-dialog v-model="isShowDialog" width="400px">
      <v-card>
        <v-card-title class="ma-0 pa-5 justify-center text-h6"></v-card-title>
        <v-card-subtitle class="mx-10 pa-0 text-left">
          <p class="ma-0 pa-0 text-body-2">
            {{ message }}
          </p>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeDialog" class="mx-2">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 表示可否を取得する
     */
    isShowDialog: {
      cache: false,
      get() {
        return this.$store.getters['commonMessageDialog/isShow'];
      },
    },
    /**
     * 表示可否を取得する
     */
    message: {
      cache: false,
      get() {
        return this.$store.getters['commonMessageDialog/message'];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * ダイアログを閉じる
     */
    closeDialog: function () {
      this.$store.commit('commonMessageDialog/close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
</style>
